import { QueryKeys, useEntity } from "@/api/core";
import { useGroupRelationship } from "@/api/group-relationships";
import { groupSchema } from "@/schemas";

function useGroupLookup(slug: string | undefined) {
  const { entity: group, ...result } = useEntity({
    queryKey: QueryKeys.groups.groupFromSlug(slug!),
    endpoint: `/api/v1/groups/lookup?slug=${slug}`,
    schema: groupSchema,
    enabled: !!slug,
    idAttributeFromVariables: "slug",
    id: slug!,
  });

  const { groupRelationship, isInitialLoading: isRelationshipInitialLoading } =
    useGroupRelationship(group?.id);

  return {
    ...result,
    isLoading: result.isLoading || isRelationshipInitialLoading,
    group: group
      ? { ...group, relationship: groupRelationship || null }
      : undefined,
  };
}

export { useGroupLookup };
